import { type CurrentUser$data } from '#app/__generated__/relay/CurrentUser.graphql.js';
import { type FeatureFlags } from '@contra/feature-flags';
import { VisitorAdvertisementCampaign } from '@contra/graphql-types';
import { createContext } from 'react';

type AppPreloadContextProps = {
  advertisementCampaigns: null | VisitorAdvertisementCampaign[];
  currentUser: CurrentUser$data | null;
  featureFlags: Partial<FeatureFlags>;
  impersonator: null | { readonly id: string };
  ipAddress: null | {
    readonly address: string;
    readonly autonomousSystem: null | {
      readonly id: string;
      readonly type: string;
    };
    readonly id: string;
  };
  sessionId: null | string;
  visitorTraits: JsonObject | null;
};
type JsonObject<T = {}> = T & { [Key in string]?: JsonValue<T> };

type JsonValue<T> =
  | Array<JsonValue<T>>
  | boolean
  | JsonObject<T>
  | null
  | number
  | string;

export const AppPreloadContext = createContext<AppPreloadContextProps>({
  advertisementCampaigns: null,
  currentUser: null,
  featureFlags: {},
  impersonator: null,
  ipAddress: null,
  sessionId: null,
  visitorTraits: null,
});
